import { ImageLibrary } from "./ImageLibrary";
import { String } from "./Strings";

// `text` is the label shown on the card. RetirementGoal maps "Current Comfort"
// to the "Maintain Status Quo" value that is persisted as idealRetirement.
export const RetirementCards = [
  {
    image: ImageLibrary.LUXURY,
    description:
      "Wish to live a luxurious 2nd Innings of life without worrying about financial liabilities while spending.",
    text: String.Retirement.SecondInning.CardName.c1,
  },
  {
    image: ImageLibrary.COMFORT,
    description:
      "Be satisfied with your current circumstances and financial situation.",
    text: "Current Comfort",
  },
  {
    image: ImageLibrary.MINIMALIST,
    description:
      "Embrace a simple and uncluttered lifestyle, focusing on essential needs.",
    text: String.Retirement.SecondInning.CardName.c3,
  },
];
